import React from 'react';
export function Header() {
  return <header className="mb-6 sm:mb-8 text-center" data-id="element-40">
      <div className="mb-3 sm:mb-4" data-id="element-41">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7t2KHX8XqCNi7tJmTHVBic/pasted-image.png" alt="KRNWTR+ Logo" className="h-16 sm:h-20 md:h-24 mx-auto" data-id="element-42" />
      </div>
      <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#052858] mb-1 sm:mb-2" data-id="element-43">
        KRNWTR+ Klantportaal
      </h1>
      <p className="text-sm sm:text-base text-gray-600" data-id="element-44">
        Vul de benodigde informatie in voor uw waterkraan installatie
      </p>
    </header>;
}